import * as ActionTypes from '../action-types'

const liveCamera_DefaultState = {
    user: {},
    selectedID: '',
    sessionID: '',
    selectedMDVRID: '',
    isLive: false
}

export const liveCamera = (state = liveCamera_DefaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state))

    if(!action) return newState

    switch (action.type) {
        case ActionTypes.GET_USER_INFO_CMS: {
            const user = action.user

            newState.user = user
            newState.sessionID = user.SessionId

            return newState
        }
        case ActionTypes.SET_SELECTED_LIVE_CAMERA_BY_VID: {
            const vid = action.vid
            const mdvrid = action.mdvrid
            const isLive = action.isLive
            const attachments = action.attachments

            newState.selectedID = vid
            newState.selectedMDVRID = mdvrid
            newState.isLive = isLive
            newState.attachments = attachments

            return newState
        }
        case ActionTypes.UNSET_SELECTED_LIVE_CAMERA_BY_VID: {
            
            newState.selectedID = ''
            newState.selectedMDVRID = ''
            newState.isLive = false
            newState.attachments = null

            return newState
        }
        default:
            return newState
    }
}